export { AdverseMediaTable } from './AdverseMediaTable'
